export const it = {
    // Login screen
    modal_login_capital: 'ACCEDI',
    placeholder_email_address: 'e-mail',
    placeholder_password: 'password',
    tooltip_forgot_password: 'Password dimenticata?',
    log_in: 'Accedi',

    // Register screen
    modal_signup_capital: 'REGISTRATI',
    placeholder_repeat_password: 'ripeti la password',
    agree: 'Accetto i ',
    terms: 'Termini',
    modal_register_capital: 'REGISTRATI',
    full_name: 'Nome completo',

    // Price options
    choose_price: 'SCEGLI IL TUO ABBONAMENTO',
    subscription_price: 'Abbonamento',
    asset_price: 'Asset',
    paywall_subscription_text:
        'Potrai cancellare il tuo abbonamento quando vuoi.',
    modal_back: 'INDIETRO',
    next_button: 'AVANTI',

    // Payments screen
    pay: 'PAGA',
    pay_with: 'PAGA CON PAYPAL',
    credit_card: 'carta di credito',
    payment_pay: 'Paga',
    payment_price: 'Costo',
    placeholder_voucher_code: 'codice coupon',
    placeholder_voucher: 'aggiungi coupon',
    card_number: 'numero della carta',
    cardholder_name: 'intestatario',

    // Forgot password
    forgot_pass_text:
        'Ti invieremo tramite mail un link per resettare la tua password.',
    remember_pass: 'Ricordi la password?',
    reset: 'RESETTA',

    // Set new password
    modal_enter_your_new_password: 'Inserisci la tua nuova password.',
    modal_please_check_your_email:
        'Per favore controlla la tua mail e copia il codice per procedere.',
    placeholder_token: 'codice',
    new_password: 'nuova password',
    repeat_new_password: 'ripeti la nuova password',
    cancel: 'Cancella',
    set: 'IMPOSTA',

    // Change password
    update: 'aggiorna',
    change_pass: 'Change password',

    // Account
    user_menu_my_account: 'Il Mio Account',
    member_since: 'Membro da',
    purchases: 'I miei Acquist',
    subscriptions: 'I miei Abbonamenti',
    account_details: 'Dettagli Account',
    export_data: 'Esporta i miei dati',
    delete_account: 'Cancella account',

    // Purchases/Subscriptions
    purchases_link: 'Acquisti',
    subscriptions_link: 'Abbonamenti',
    subscriptions_text:
        'These are all the assets you have purchased and how long you have access to it.',
    purchase_history: 'Storico acquisti',
    purchased: 'Acquistato',
    name: 'nome',
    active: 'attivo',
    inactive: 'inactive',
    canceled: 'cancellato',
    type: 'Tipo',
    next_transaction: 'prossima transazione',
    cancel_subscription: 'Cancella abbonamento >',
    subscriptions_active: 'Abbonamenti attivi',
    expires_at: 'Scade il',
    no_more_subscriptions: 'Non ci sono più abbonamenti.',
    no_available_subscriptions: 'Non ci sono più abbonamenti disponibili.',
    no_more_active_accesses: 'Non ci sono più accessi attivi.',
    no_more_inactive_accesses: 'Non ci sono più accessi inattivi.',
    no_available_active_accesses: 'Non ci sono più accessi attivi disponibili.',
    no_available_inactive_accesses:
        'Non ci sono più accessi inattivi disponibili.',
    subscription: 'Subscription',
    free_trial: 'Free Trial',
    cancel_subscription_header:
        'Are you sure you want to cancel your subscription?',
    cancel_subscription_paragraph_first:
        'This will end your subscription for the',
    cancel_subscription_paragraph_second:
        'You will still have access to everything until the active period ends on the',
    cancel_subscription_confirm: 'Yes, cancel',
    will_end: 'Subscription will end',

    // Export data screen
    export_question: 'Confermi di voler esportare i tuoi dati?',
    export: 'esporta',
    first_export:
        'L’azione Export dei Dati personali esporterà tutti i tuoi dati personali contenuti nell’account. Questo include i seguenti:',
    second_export: 'I tuoi dati personali',
    third_export: 'Storico dei tuoi accessi ',
    fourth_export: 'Lista dei tuoi abbonamenti',
    fifth_export: 'Lista dei tuoi pagamenti',
    sixth_export: 'Lista dei tuoi accessi a contenuti Premium',
    last_export:
        'I dati esportati saranno inviati alla tua mail come allegato.',

    // Delete account screen
    delete_question: 'Confermi di voler cancellare il tuo account?',
    delete: 'cancella',
    confirm: '‘CONFERMA',
    first_delete:
        'L’azione Cancella il Tuo Account eliminerà tutti i tuoi dati personali dal sistema. Questo include:',
    second_delete: 'Informazioni personali fornite durante la registrazione',
    third_delete:
        'Posizione e dettagli dei dispositivi raccolti durante il processo di autenticazione',
    fourth_delete:
        'Tutti gli altri dati personali conservati in altre parti del nostro database',
    fifth_delete:
        'Gli unici dati personali che rimarranno in nostro possesso saranno quelli relativi alle transazioni ed abbonamenti, a causa di altre leggi che dobbiamo rispettare.',
    sixth_delete:
        'Oltre all’eliminazione dei dati, il tuo account sarà inattivato, per cui tutte gli abbonamenti attivi verranno cancellati, i tuoi accessi funzionanti ai nostri servizi saranno revocati e tutte le sessioni di accesso attualmente attive inclusa questa verranno terminate. Non sarai più in grado di autenticare ed acquistare servizi su questo sito. Le informazioni del tuo account non saranno più accessibili da nessuna parte al nostro staff.',
    seventh_delete:
        'Quest’azione potrebbe richiedere 1-2 giorni per essere completata, dopo i quali una mail di conferma sarà inviata al tuo indirizzo e-mail. Tale mail sarà cancellata dai nostri sistemi dopo una confermata consegna',

    // Inputs validation
    required_field: 'Campi obbligatori',
    email_field: 'per favore inserisci un indirizzo mail valido',
    number_field: 'Il dato inserito deve essere un numero',
    matchPass: 'le password non coincidono',
    minpass_field: 'deve essere lunga almeno 8 caratteri',
    minname_field: 'deve essere lungo almeno 2 caratteri',

    // Footer
    modal_terms: 'Termini',
    modal_privacy: 'Privacy',
    modal_more: 'Di più ',
    modal_faq: 'FAQ',
    modal_protected: 'Cosa è questo?',
    logout: 'Esci',
    details: 'I miei dettagli',
    preview_protected_by_inplayer: 'Protetto da',
    modal_support: 'Support',

    dlc_download: 'download',
};



// WEBPACK FOOTER //
// ./src/i18n/italian.js